var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36155 0.845703C4.80155 0.845703 2.71155 2.9357 2.71155 5.4957C2.71155 6.5857 3.11155 7.5857 3.74155 8.3757L0.921553 11.0257C0.661553 11.2757 0.641553 11.6857 0.891553 11.9457C1.02155 12.0857 1.19155 12.1557 1.36155 12.1557C1.52155 12.1557 1.68155 12.0957 1.80155 11.9757L4.67155 9.2857C5.43155 9.8257 6.35155 10.1557 7.35155 10.1557C9.91155 10.1557 12.0016 8.0657 12.0016 5.5057C12.0016 2.9457 9.92155 0.845703 7.36155 0.845703ZM7.36155 8.8457C5.51155 8.8457 4.01155 7.3457 4.01155 5.4957C4.01155 3.6457 5.51155 2.1457 7.36155 2.1457C9.21155 2.1457 10.7116 3.6457 10.7116 5.4957C10.7116 7.3457 9.21155 8.8457 7.36155 8.8457Z",
    fill: "#444F59",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e51ed0e6beb0c6e7342b79318948c587.svg";
export { ForwardRef as ReactComponent };